import { I18nFragment } from '@diagentech/exprworks-ui-components';
import Link from '@mui/material/Link';
import React, { useCallback } from 'react';

import { useAppDispatch } from '@/App/hooks';
import { COOKIE_CONSENT_DIALOG_ID } from '@/components/layout/AppCookieConsent/CookieConsentDialog';
import { setShowCookieSettings } from '@/features/ui/uiSlice';

export const CookieSettingsLink: React.FC = () => {
  const dispatch = useAppDispatch();

  const showCookieSettings = useCallback(() => {
    dispatch(setShowCookieSettings(true));
  }, [dispatch]);

  return (
    <Link
      variant="body2"
      component="button"
      aria-controls={COOKIE_CONSENT_DIALOG_ID}
      aria-haspopup="true"
      onClick={showCookieSettings}
    >
      <I18nFragment id="SH.BTN.COOKIESETTINGS" />
    </Link>
  );
};
